export const InsightAnswerCssClass = 'insight-reference';
export const InsightAnswerLabelPrefix = 'Insight reference';
